// extracted by mini-css-extract-plugin
export default {"createCreativeErrorList":"creativeErrorsModal_createCreativeErrorList__WRXnH","createCreativeErrorModal":"creativeErrorsModal_createCreativeErrorModal__SyoyK"};